
import React from 'react';

export default (props) => {
  
        return (
              <div className="pull-right">
                <a href={void(0)} className="acaoRemover" onClick={props.funcao}>x</a>
                </div>
               );
  
}



// WEBPACK FOOTER //
// ./src/container/btAcaoRemoverItem.js